var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIreland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8506C24.8366 32.8506 32 25.6871 32 16.8506C32 8.01403 24.8366 0.850586 16 0.850586C7.16344 0.850586 0 8.01403 0 16.8506C0 25.6871 7.16344 32.8506 16 32.8506Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.8505C32 9.97108 27.658 4.10633 21.5652 1.8457V31.8554C27.658 29.5946 32 23.73 32 16.8505Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8505C0 23.73 4.342 29.5946 10.4348 31.8553V1.8457C4.342 4.10633 0 9.97108 0 16.8505Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.850586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIreland);
export default __webpack_public_path__ + "static/media/flag_ireland.3213971df352be8a3fe0da64c9602210.svg";
export { ForwardRef as ReactComponent };